/* eslint-disable spellcheck/spell-checker */
const NEW_ZEALAND = 'New Zealand'
const UNITED_KINGDOM = 'United Kingdom'
const UNITED_STATES = 'United States'

export enum AdCampaignCountriesTierEnum {
  CUSTOM = 'custom',
  TOP_ENGAGED = 'top_engaged',
}

export const ADS_COUNTRIES: Record<AdCampaignCountriesTierEnum, string[]> = {
  [AdCampaignCountriesTierEnum.TOP_ENGAGED]: [
    'Austria',
    'Australia',
    'Belgium',
    'Brazil',
    'Canada',
    'Switzerland',
    'Cyprus',
    'Czech Republic',
    'Germany',
    'Denmark',
    'Estonia',
    'Spain',
    'Finland',
    'France',
    UNITED_KINGDOM,
    'French Guiana',
    'Hong Kong',
    'Ireland',
    'Iceland',
    'Italy',
    'Japan',
    'Luxembourg',
    'Latvia',
    'Monaco',
    'Malta',
    'Mexico',
    'Netherlands',
    'Norway',
    NEW_ZEALAND,
    'French Polynesia',
    'Poland',
    'Portugal',
    'Sweden',
    UNITED_STATES,
    'Colombia',
    'Chile',
    'Peru',
    'Argentina',
    'Bolivia',
    'Ecuador',
    'Israel',
    'Croatia',
    'Romania',
  ],
  [AdCampaignCountriesTierEnum.CUSTOM]: [
    'Algeria',
    'Angola',
    'Benin',
    'Botswana',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cameroon',
    'Chad',
    'Comoros',
    'Congo',
    "Cote d'Ivoire",
    'Democratic Republic of the Congo',
    'Djibouti',
    'Egypt',
    'Equatorial Guinea',
    'Ethiopia',
    'Gabon',
    'Gambia',
    'Ghana',
    'Guinea',
    'Guinea-Bissau',
    'Kenya',
    'Lesotho',
    'Liberia',
    'Libya',
    'Madagascar',
    'Malawi',
    'Mali',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Niger',
    'Nigeria',
    'Rwanda',
    'Réunion',
    'Saint Helena',
    'Sao Tome and Principe',
    'Senegal',
    'Seychelles',
    'Sierra Leone',
    'South Africa',
    'Swaziland',
    'Togo',
    'Tunisia',
    'Uganda',
    'Tanzania',
    'Zambia',
    'Zimbabwe',
    'Armenia',
    'Azerbaijan',
    'Bahrain',
    'Bangladesh',
    'Bhutan',
    'Brunei Darussalam',
    'Cambodia',
    'Cyprus',
    'Georgia',
    'Hong Kong',
    'India',
    'Indonesia',
    'Iraq',
    'Israel',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kuwait',
    'Kyrgyzstan',
    "Lao People's Democratic Republic",
    'Lebanon',
    'Macao',
    'Maldives',
    'Mongolia',
    'Nepal',
    'Oman',
    'Pakistan',
    'Philippines',
    'Qatar',
    'South Korea',
    'Saudi Arabia',
    'Singapore',
    'Sri Lanka',
    'Tajikistan',
    'Thailand',
    'Timor-Leste',
    'Turkey',
    'United Arab Emirates',
    'Uzbekistan',
    'Viet Nam',
    'Anguilla',
    'Antigua and Barbuda',
    'Aruba',
    'Bahamas',
    'Barbados',
    'Bonaire, Sint Eustatius and Saba',
    'British Virgin Islands',
    'Cayman Islands',
    'Curaçao',
    'Dominica',
    'Dominican Republic',
    'Grenada',
    'Guadeloupe',
    'Haiti',
    'Jamaica',
    'Martinique',
    'Montserrat',
    'Puerto Rico',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Martin',
    'Saint Vincent and the Grenadines',
    'Saint-Barthélemy',
    'Sint Maarten',
    'Trinidad and Tobago',
    'Turks and Caicos Islands',
    'United States Virgin Islands',
    'Belize',
    'Costa Rica',
    'El Salvador',
    'Guatemala',
    'Honduras',
    'Mexico',
    'Nicaragua',
    'Panama',
    'Albania',
    'Andorra',
    'Austria',
    'Belarus',
    'Belgium',
    'Bosnia and Herzegovina',
    'Bulgaria',
    'Channel Islands',
    'Croatia',
    'Czech Republic',
    'Denmark',
    'Estonia',
    'Faeroe Islands',
    'Finland',
    'France',
    'Germany',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Guernsey',
    'Hungary',
    'Iceland',
    'Ireland',
    'Isle of Man',
    'Italy',
    'Jersey',
    'Latvia',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Malta',
    'Monaco',
    'Montenegro',
    'Netherlands',
    'Norway',
    'Poland',
    'Portugal',
    'Moldova',
    'Romania',
    'San Marino',
    'Sark',
    'Serbia',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Svalbard and Jan Mayen Islands',
    'Sweden',
    'Switzerland',
    'Macedonia',
    'Ukraine',
    'United Kingdom',
    'Åland Islands',
    'Bermuda',
    'Canada',
    'Saint Pierre and Miquelon',
    'United States',
    'American Samoa',
    'Australia',
    'Cook Islands',
    'Fiji',
    'French Polynesia',
    'Guam',
    'Kiribati',
    'Marshall Islands',
    'Micronesia',
    'Nauru',
    'New Caledonia',
    'New Zealand',
    'Niue',
    'Norfolk Island',
    'Northern Mariana Islands',
    'Palau',
    'Papua New Guinea',
    'Pitcairn',
    'Samoa',
    'Solomon Islands',
    'Tokelau',
    'Tonga',
    'Tuvalu',
    'Vanuatu',
    'Wallis and Futuna Islands',
    'Argentina',
    'Bolivia',
    'Brazil',
    'Chile',
    'Colombia',
    'Ecuador',
    'Falkland Islands (Malvinas)',
    'French Guiana',
    'Guyana',
    'Paraguay',
    'Peru',
    'Suriname',
    'Uruguay',
    'Venezuela',
  ].sort((a, b) => a.localeCompare(b)),
}
